// import React, { useState, useEffect } from "react";
// import axiosInstance from "../../../../axios";
// import { Loading } from "@/pages/Other/Loading";
// import Modal from "@/pages/Other/Modal";

// const InstructorAttendance = () => {
//     const [instructors, setInstructors] = useState([]);
//     console.log("Instructors:", instructors);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     // Modal state
//     const [showModal, setShowModal] = useState(false);
//     const [selectedInstructor, setSelectedInstructor] = useState(null);

//     // Attendance state for modal
//     const [checkInTime, setCheckInTime] = useState("");
//     const [marking, setMarking] = useState(false);
//     const [attendanceRecords, setAttendanceRecords] = useState([]);
//     const [attendanceLoading, setAttendanceLoading] = useState(false);
//     const [attendanceError, setAttendanceError] = useState(null);
//     const [filters, setFilters] = useState({
//         startDate: "",
//         endDate: "",
//     });
//     const todayDate = new Date().toISOString().split("T")[0];
//     // Fetch instructors list
//     const fetchInstructors = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             const response = await axiosInstance.get("/user/teacher");
//             // Ensure we always set an array
//             setInstructors(Array.isArray(response.data?.data?.data) ? response?.data?.data?.data : []);
//         } catch (err) {
//             setError("Failed to fetch instructors.");
//             setInstructors([]); // fallback to empty array on error
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch attendance for selected instructor
//     const fetchAttendanceRecords = async (instructorId, filterParams = {}) => {
//         setAttendanceLoading(true);
//         setAttendanceError(null);
//         try {
//             const response = await axiosInstance.get("/admin/instructor-attendance", {
//                 params: {
//                     instructorId,
//                     ...filterParams,
//                 },
//             });
//             setAttendanceRecords(response?.data?.data);
//         } catch (err) {
//             setAttendanceError("Failed to fetch attendance records.");
//         } finally {
//             setAttendanceLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchInstructors();
//     }, []);

//     const getToday = () => new Date().toISOString().split("T")[0];

//     // Open modal and fetch attendance
//     const handleViewAttendance = (instructor) => {
//         const today = getToday();
//         setSelectedInstructor(instructor);
//         setShowModal(true);
//         setFilters({ startDate: today, endDate: today }); // Set to today
//         fetchAttendanceRecords(instructor.userId, { startDate: today, endDate: today });
//     };

//     // Handle filter change in modal
//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters((prev) => ({ ...prev, [name]: value }));
//     };

//     // Handle filter submit in modal
//     const handleFilterSubmit = (e) => {
//         e.preventDefault();
//         if (selectedInstructor) {
//             fetchAttendanceRecords(selectedInstructor.userId, filters);
//         }
//     };
//     // Clear filters and reset to default dates
//     const handleClearFilter = () => {
//         const today = getToday();
//         const defaultFilters = {
//             startDate: today,
//             endDate: today,
//         };
//         setFilters(defaultFilters);
//         if (selectedInstructor) {
//             fetchAttendanceRecords(selectedInstructor.userId, defaultFilters);
//         }
//     };
//     // Close modal
//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedInstructor(null);
//         setAttendanceRecords([]);
//     };
//     const markCheckIn = async (instructorId) => {
//         if (!checkInTime) return;
//         setMarking(true);
//         try {
//             const payload = {
//                 instructorId,
//                 date: todayDate,
//                 status: "Present",
//                 checkInTime,
//             };
//             await axiosInstance.post("/instructor/attendance", payload);
//             alert("Check-In recorded!");
//             setCheckInTime("");
//         } catch (err) {
//             console.error("Check-In Error:", err);
//             alert(err.response?.data?.message || "Check-in failed");
//         } finally {
//             setMarking(false);
//         }
//     };
//     const handleRowCheckOut = async (record, index) => {
//     const checkOutTime = record.manualCheckOut;
//     if (!checkOutTime) return;

//     setMarking(true);
//     try {
//       const payload = {
//         instructorId,
//         date: record.date,
//         status: record.status || "Present",
//         checkOutTime,
//         checkInTime: null, // To avoid duplicate check-in creation
//       };

//       await axiosInstance.post("/instructor/attendance", payload);
//       alert("Check-Out recorded!");
//       fetchHistory();
//     } catch (err) {
//       console.error("Check-Out Error:", err);
//       alert(err.response?.data?.message || "Check-out failed");
//     } finally {
//       setMarking(false);
//     }
//   };
//     return (
//         <div className="mx-auto p-6">
//             <div className="dashboard-container-new !mb-6">
//                 <p>Instructor Attendance</p>
//             </div>

//             {loading && <p className="text-center text-blue-600 font-medium"><Loading /></p>}
//             {error && <p className="text-center text-red-600 font-medium">{error}</p>}

//             {!loading && !error && (
//                 <div className="instructor-table">
//                     <table className="table-width-100">
//                         <thead>
//                             <tr>
//                                 <th>ID</th>
//                                 <th>Instructor Name</th>
//                                 <th>Email</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {instructors.map((instructor) => (
//                                 <tr key={instructor.id}>
//                                     <td className="cell">{instructor.userIds}</td>
//                                     <td className="cell">{instructor.firstName}</td>
//                                     <td className="cell">{instructor.email}</td>
//                                     <td className="cell">
//                                         <button
//                                             className="bg-[#264b82] text-white py-1 px-3 rounded hover:bg-blue-700"
//                                             onClick={() => handleViewAttendance(instructor)}
//                                         >
//                                             View Attendance
//                                         </button>
                                
//                                         <input
//                                             type="time"
//                                             className="!w-[200px] mr-2 ml-10"
//                                             placeholder="Check-In"
//                                             onChange={(e) => setCheckInTime(e.target.value)}
//                                         />
//                                         <button
//                                             className="bg-[#264b82] text-white py-1 px-3 rounded hover:bg-blue-700"
//                                             onClick={() => markCheckIn(instructor.userId)}
//                                              disabled={marking || !checkInTime}
//                                         >
//                                             Mark Check-In
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {/* Modal */}
//             {showModal && (
//                 <Modal isOpen={showModal} onClose={handleCloseModal}>
//                     <div className="flex items-center justify-content-between bg-[#0e63e2] rounded-md mb-2 py-3">
//                         <h2 className="text-white font-bold text-xl pl-3">
//                             Attendance for {selectedInstructor?.firstName || "Instructor"}
//                         </h2>
//                     </div>
//                     <div className="bg-white rounded-lg p-6 w-full max-w-2xl relative">
//                         <form onSubmit={handleFilterSubmit} className="flex items-center gap-4 mb-4">
//                             <div>
//                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                     Start Date:
//                                 </label>
//                                 <input
//                                     type="date"
//                                     name="startDate"
//                                     value={filters.startDate}
//                                     onChange={handleFilterChange}
//                                     className="px-3 py-2 border border-gray-300 rounded-md"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                     End Date:
//                                 </label>
//                                 <input
//                                     type="date"
//                                     name="endDate"
//                                     value={filters.endDate}
//                                     onChange={handleFilterChange}
//                                     className="px-3 py-2 border border-gray-300 rounded-md"
//                                 />
//                             </div>
//                             <div>
//                                 <button
//                                     type="submit"
//                                     className="bg-[#264b82] text-white py-2 px-4 rounded hover:bg-blue-700 mt-6"
//                                 >
//                                     Filter
//                                 </button>
//                             </div>
//                             <div>
//                                 <button
//                                     type="button"
//                                     onClick={handleClearFilter}
//                                     className="bg-gray-300 text-black py-2 px-4 rounded hover:bg-gray-400 mt-6"
//                                 >
//                                     Clear Filter
//                                 </button>
//                             </div>
//                         </form>
//                         {attendanceLoading && <Loading />}
//                         {attendanceError && (
//                             <p className="text-red-600 font-medium">{attendanceError}</p>
//                         )}
//                         {!attendanceLoading && !attendanceError && (
//                             <div className="overflow-x-auto">
//                                 <table className="table-width-100">
//                                     <thead>
//                                         <tr>
//                                             <th>Date</th>
//                                             <th>Check-In</th>
//                                             <th>Check-Out</th>
//                                             <th>Status</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {attendanceRecords.length > 0 ? (
//                                             attendanceRecords.map((record, idx) => (
//                                                 <tr key={idx}>
//                                                     <td className="cell">{record.date}</td>
//                                                     <td className="cell">{record.checkInTime || "N/A"}</td>
//                                                     <td className="cell">{record.checkOutTime || "N/A"}</td>
//                                                     <td className="cell">{record.status}</td>
//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             <tr>
//                                                 <td colSpan={4} className="text-center text-gray-600">
//                                                     No attendance records found.
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}
//                     </div>
//                 </Modal>
//             )}
//         </div>
//     );
// };

// export default InstructorAttendance;

import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "@/pages/Other/Loading";
import Modal from "@/pages/Other/Modal";

const InstructorAttendance = () => {
  const [instructors, setInstructors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedInstructor, setSelectedInstructor] = useState(null);

  // Attendance state for modal
  const [checkInTime, setCheckInTime] = useState("");
  const [marking, setMarking] = useState(false);
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [attendanceError, setAttendanceError] = useState(null);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
  });

  const todayDate = new Date().toISOString().split("T")[0];

  // Fetch instructors
  const fetchInstructors = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get("/user/teacher");
      setInstructors(
        Array.isArray(response.data?.data?.data)
          ? response.data.data.data
          : []
      );
    } catch (err) {
      setError("Failed to fetch instructors.");
      setInstructors([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch attendance
  const fetchAttendanceRecords = async (instructorId, filterParams = {}) => {
    setAttendanceLoading(true);
    setAttendanceError(null);
    try {
      const response = await axiosInstance.get("/admin/instructor-attendance", {
        params: { instructorId, ...filterParams },
      });
      setAttendanceRecords(response?.data?.data || []);
    } catch (err) {
      setAttendanceError("Failed to fetch attendance records.");
    } finally {
      setAttendanceLoading(false);
    }
  };

  useEffect(() => {
    fetchInstructors();
  }, []);

  const getToday = () => new Date().toISOString().split("T")[0];

  // Open modal
  const handleViewAttendance = (instructor) => {
    const today = getToday();
    setSelectedInstructor(instructor);
    setShowModal(true);
    setFilters({ startDate: today, endDate: today });
    fetchAttendanceRecords(instructor.userId, {
      startDate: today,
      endDate: today,
    });
  };

  // Filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Filter submit
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (selectedInstructor) {
      fetchAttendanceRecords(selectedInstructor.userId, filters);
    }
  };

  // Clear filter
  const handleClearFilter = () => {
    const today = getToday();
    const defaultFilters = { startDate: today, endDate: today };
    setFilters(defaultFilters);
    if (selectedInstructor) {
      fetchAttendanceRecords(selectedInstructor.userId, defaultFilters);
    }
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedInstructor(null);
    setAttendanceRecords([]);
  };

  // Mark Check-In
  const markCheckIn = async (instructorId) => {
    if (!checkInTime) return;
    setMarking(true);
    try {
      const payload = {
        instructorId,
        date: todayDate,
        status: "Present",
        checkInTime,
      };
      await axiosInstance.post("/instructor/attendance", payload);
      alert("Check-In recorded!");
      setCheckInTime("");

      // Refresh attendance if modal is open
      if (selectedInstructor?.userId === instructorId) {
        fetchAttendanceRecords(instructorId, filters);
      }
    } catch (err) {
      alert(err.response?.data?.message || "Check-in failed");
    } finally {
      setMarking(false);
    }
  };

  // Mark Check-Out
  const handleRowCheckOut = async (record) => {
    if (!record.manualCheckOut) {
      alert("Please set a checkout time before submitting.");
      return;
    }

    setMarking(true);
    try {
      const payload = {
        instructorId: selectedInstructor.userId,
        date: record.date,
        status: record.status || "Present",
        checkOutTime: record.manualCheckOut,
      };

      await axiosInstance.post("/instructor/attendance", payload);
      alert("Check-Out recorded!");
      fetchAttendanceRecords(selectedInstructor.userId, filters);
    } catch (err) {
      alert(err.response?.data?.message || "Check-out failed");
    } finally {
      setMarking(false);
    }
  };

  // Handle manual checkout time input change
  const handleManualCheckoutChange = (index, value) => {
    setAttendanceRecords((prev) =>
      prev.map((rec, i) =>
        i === index ? { ...rec, manualCheckOut: value } : rec
      )
    );
  };

  return (
    <div className="mx-auto p-6">
      <div className="dashboard-container-new !mb-6">
        <p>Instructor Attendance</p>
      </div>

      {loading && <p className="text-center text-blue-600 font-medium"><Loading /></p>}
      {error && <p className="text-center text-red-600 font-medium">{error}</p>}

      {!loading && !error && (
        <div className="instructor-table">
          <table className="table-width-100">
            <thead>
              <tr>
                <th>ID</th>
                <th>Instructor Name</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {instructors.map((instructor) => (
                <tr key={instructor.id}>
                  <td className="cell">{instructor.userIds}</td>
                  <td className="cell">{instructor.firstName}</td>
                  <td className="cell">{instructor.email}</td>
                  <td className="cell">
                    <button
                      className="bg-[#264b82] text-white py-1 px-3 rounded hover:bg-blue-700"
                      onClick={() => handleViewAttendance(instructor)}
                    >
                      View Attendance
                    </button>

                    <input
                      type="time"
                      className="!w-[200px] mr-2 ml-10"
                      onChange={(e) => setCheckInTime(e.target.value)}
                    />
                    <button
                      className="bg-[#264b82] text-white py-1 px-3 rounded hover:bg-blue-700"
                      onClick={() => markCheckIn(instructor.userId)}
                      disabled={marking || !checkInTime}
                    >
                      Mark Check-In
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <Modal isOpen={showModal} onClose={handleCloseModal}>
          <div className="dashboard-container-new !mb-2 py-3">
            <h2 className="pl-3">
              Attendance for {selectedInstructor?.firstName || "Instructor"}
            </h2>
          </div>
          <div className="bg-white rounded-lg p-6 w-full relative">
            {/* Filters */}
            <form onSubmit={handleFilterSubmit} className="flex items-center gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Start Date:
                </label>
                <input
                  type="date"
                  name="startDate"
                  value={filters.startDate}
                  onChange={handleFilterChange}
                  className="px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  End Date:
                </label>
                <input
                  type="date"
                  name="endDate"
                  value={filters.endDate}
                  onChange={handleFilterChange}
                  className="px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="bg-[#264b82] text-white py-2 px-4 rounded hover:bg-blue-700 mt-6"
                >
                  Filter
                </button>
              </div>
              <div>
                <button
                  type="button"
                  onClick={handleClearFilter}
                  className="bg-gray-300 text-black py-2 px-4 rounded hover:bg-gray-400 mt-6"
                >
                  Clear Filter
                </button>
              </div>
            </form>

            {/* Attendance Table */}
            {attendanceLoading && <Loading />}
            {attendanceError && <p className="text-red-600 font-medium">{attendanceError}</p>}

            {!attendanceLoading && !attendanceError && (
              <div className="overflow-x-auto">
                <table className="table-width-100">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Check-In</th>
                      <th>Check-Out</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendanceRecords.length > 0 ? (
                      attendanceRecords.map((record, idx) => (
                        <tr key={idx}>
                          <td className="cell">{record.date}</td>
                          <td className="cell">{record.checkInTime || "N/A"}</td>
                          <td className="cell">{record.checkOutTime || "N/A"}</td>
                          <td className="cell">{record.status}</td>
                          <td className="cell">
                            <input
                              type="time"
                              value={record.manualCheckOut || ""}
                                className="!w-[100px] !py-1 !px-2"
                              onChange={(e) =>
                                handleManualCheckoutChange(idx, e.target.value)
                              }
                            />
                            <button
                              className="ml-2 bg-green-600 text-white px-3 py-1 rounded"
                              onClick={() => handleRowCheckOut(record)}
                              disabled={marking}
                            >
                              Check-Out
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center text-gray-600">
                          No attendance records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default InstructorAttendance;

